import axios from "axios";
import "../../css/backlink-gap.scss";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { DottLoader } from "../../share/loader";
import { ZustandStore } from "../../../store/zustand-store";
import { Button, Paper, TablePagination } from "@mui/material";
import { ScrollToView } from "../../share/helper-js/scroll-into-view";
import { curday, formatDate } from "../../share/upDater/constant";
import { CSVLink } from "react-csv";
import LineAlert from "../../share/components/lineAlert";
import addIcon from "../../Assets/rank-tracking-assets/add.svg";
import { CiCircleList } from "react-icons/ci";
import { FiDownload } from "react-icons/fi";
import { Delete } from "@mui/icons-material";
import AlertPopUp from "../../share/components/alert.component";
import PopOver from "../../share/components/popover.component";
import LastCheck from "../Search-History/LastCheck";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Grid, IconButton, Typography } from "@mui/material";
import { domainRegex, handleInvitedUserAccess } from "../../../helperJs/helper";
import { handleSaveHistory } from "../Search-History/searchOperations";
import HistoryIcon from "@mui/icons-material/History";

import { ReactComponent as YouSvg } from "../../Assets/backlink/bac-gap-you.svg";
import { ReactComponent as YouDotSvg } from "../../Assets/backlink/bac-gap-dot.svg";
import { ReactComponent as YouBlueDotSvg } from "../../Assets/backlink/bac-gap-you-dot.svg";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

// images
import { IoClose } from "react-icons/io5";
import {
  DELETE_LIST_BACKLINKS,
  GET_ALLLIST_BACKLINKS,
  POST_NEWLIST_BACKLINKS,
  PUT_ADDBACKLINKS,
  USER_BACKLINK_LIST_URL,
  USER_BACKLINK_LIST_URLEML,
  get_backlink_data,
  get_backlinktotallmtGet,
  get_user_backlinklimit,
  post_backlink_data,
  post_backlinktotallmt,
  post_morebacklink,
  post_user_backlinklimit,
  update_backlinktotallmtupdate,
  update_user_backlinklimit,
} from "../../../services/constants";
import exportIcon from "../../Assets/rank-tracking-assets/export-file.svg";
import DomainRankPdfModal from "../Modals/PdfModals/DomainRankPdfModal";
import PdfModalDialog from "../../share/pdf/PdfModalDialog";
import DropdownList from "../../share/components/DropdownList";
import CollapsibleTable from "../../share/tables/backlink-gap/collapse-table";
import { useTranslation } from "react-i18next";
import { useTableBlur } from "../../share/custom-hook/useTableBlur";
import AddProjectStore from "../../../store/AddProjectStore";

function TablePaginationActions(
  props,
  tableListData,
  tableMessage,
  handleLoadMoreResultData
) {
  const { page, onPageChange, rowsPerPage, count } = props;
  const { t } = useTranslation();

  const loadedData = useMemo(() => {
    return tableListData?.length === count;
  }, [tableListData, count]);

  // Determine if all data is loaded
  const isAllDataLoaded = useMemo(() => {
    const totalLoaded = (page + 1) * rowsPerPage;
    return totalLoaded >= count;
  }, [page, rowsPerPage, count]);

  const handleLoadMoreResultsButtonClick = () => {
    handleLoadMoreResultData();
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        aria-label="previous page"
        disabled={page === 0}
        sx={{
          "& .Mui-disabled": {
            backgroundColor: "transparent !important",
          },
        }}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        aria-label="next page"
        disabled={isAllDataLoaded}
      >
        <KeyboardArrowRight />
      </IconButton>

      {tableMessage ? (
        <Button
          className="m-3 mx-4 btn_1"
          disabled={true}
          variant="contained"
          color="primary"
        >
          {tableMessage}
        </Button>
      ) : (
        <Button
          className="m-3 mx-4 btn_1"
          variant="contained"
          disabled={!loadedData}
          color="primary"
          onClick={handleLoadMoreResultsButtonClick}
        >
          {t("backlinks.backlink_analysis.backlinks_table.load_more")}
        </Button>
      )}
    </Box>
  );
}

const BacklinkGap = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const email = localStorage.getItem("admin_mail");
  const { gap_analyser_data, userAccessData } = ZustandStore((state) => state);
  const queryParams = new URLSearchParams(location.search);
  const backlinklimits = useSelector((state) => state.backlinkLimit);
  const userRowLmt = backlinklimits?.backlinks_rows_limit;
  const EMAIL = useSelector((state) => state.email);
  const page_data = userAccessData?.[0]?.access;
  const isPageAccess = handleInvitedUserAccess("backlinksgap", page_data);
  const [domain, setDomain] = useState({
    you: "",
    competitor_1: "",
  });
  const [Error, setError] = useState({
    msg: "",
    show: false,
  });
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableMoreData, setTableMoreData] = useState({
    you: [],
    competitor: [],
  });
  const [tableMessage, setTableMessage] = useState("");
  const [Page, setPage] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [limitAlert, setLimitAlert] = useState("");
  const [tableLoader, setTableLoader] = useState(true);
  const [selectedData, setSelectedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  //list api
  const [Alert, setAlert] = useState({
    type: "",
    message: "",
    show: false,
  });

  const [anchorEl, setAnchorEl] = useState(false);
  const [CreateList, setCreateList] = useState(false);
  const [ViewAllLists, setViewAllLists] = useState([]);
  const [ListValue, setListValue] = useState("");
  const [alertMsg, setalertMsg] = useState(false);
  const [ListChooseErr, setListChooseErr] = useState(false);
  const [inputEmptyErr, setinputEmptyErr] = useState(false);
  const [DeleteLoading, setDeleteLoading] = useState(false);
  const [ListName, setListName] = useState("");

  function handleClose() {
    setAnchorEl(false);
    setListValue("");
    setalertMsg(false);
    setinputEmptyErr(false);
    setTimeout(() => {
      setCreateList(false);
    }, 500);
    setListName("");
  }
  const showNotification = AddProjectStore((state) => state.showNotification);

  const maxAllowedPage = 1; // for trial users
  const shouldTableBlur = useTableBlur({
    currentPage: Page,
    blurFromPage: maxAllowedPage,
  });

  const HandleOpenAddList = () => {
    setCreateList(true);
  };

  const HandleOpen = () => {
    setAnchorEl(true);
  };

  const filterOptionArr = [
    t("backlinks.backlinks_gap.filter.dr"),
    t("backlinks.backlinks_gap.filter.follow"),
    t("backlinks.backlinks_gap.filter.no_follow"),
    t("backlinks.backlinks_gap.filter.all"),
  ];
  const handleTabChange = (newValue) => {
    const index = filterOptionArr.indexOf(newValue);
    setTabValue(index);
  };

  const handleInputChange = (event) => {
    setError({
      msg: "",
      show: false,
    });
    const { name, value } = event.target;
    const match = value.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
    const domain = match ? match[1].replace(/\s/g, "") : "";
    setDomain((prevDomain) => ({
      ...prevDomain,
      [name]: domain, // Dynamically update the state based on the input field name
    }));
  };

  useEffect(() => {
    const you = sessionStorage.getItem("yourlastbacklinkdomain");
    const competitor = sessionStorage.getItem("competitorlastbacklinkdomain");
    if (!isPageAccess) {
      sessionStorage.removeItem("yourlastbacklinkdomain");
      sessionStorage.removeItem("competitorlastbacklinkdomain");
    } else if (gap_analyser_data?.length > 0) {
      if (you != null && competitor != null) {
        setDomain({
          you: you,
          competitor_1: competitor,
        });
        addQueryParamToURL(you, competitor);
      }
    }
  }, [gap_analyser_data, isPageAccess]);

  const you_table_data =
    gap_analyser_data?.[0]?.data?.data?.[0]?.data ||
    gap_analyser_data?.[0]?.data?.[0]?.data;

  const competitor_table_data =
    gap_analyser_data?.[1]?.data?.data?.[0]?.data ||
    gap_analyser_data?.[1]?.data?.[0]?.data;
  const you_total_backlinks =
    gap_analyser_data?.[0]?.data?.data?.[0]?.total_backlinks ||
    gap_analyser_data?.[0]?.data?.[0]?.total_backlinks;
  const competitor_total_backlinks =
    gap_analyser_data?.[1]?.data?.data?.[0]?.total_backlinks ||
    gap_analyser_data?.[1]?.data?.[0]?.total_backlinks;
  const you_history_list =
    gap_analyser_data?.[0]?.data?.data?.[0]?.history_list ||
    gap_analyser_data?.[0]?.data?.[0]?.history_list;
  const competitor_history_list =
    gap_analyser_data?.[1]?.data?.data?.[0]?.history_list ||
    gap_analyser_data?.[1]?.data?.[0]?.history_list;

  function getGapAnalyserData(you_data, competitor_data) {
    if (competitor_data?.length === 0) return [];
    if (you_data?.length === 0) return [];

    function extractDomain(url) {
      let domain;
      if (url?.indexOf("://") > -1) {
        domain = url?.split("/")[2];
      } else {
        domain = url?.split("/")[0];
      }
      domain = domain?.split(":")[0];
      return domain;
    }

    const youDomainSet = new Set(
      you_data?.map((item) => extractDomain(item?.url_from))
    );

    return competitor_data?.filter((obj) => {
      const url = obj?.url_from;
      const domain = extractDomain(url);
      return !youDomainSet.has(domain);
    });
  }

  const sortRows = (rows, config) => {
    if (rows?.length === 0) return [];
    if (!config.key) return rows; // Return original rows if no sorting key is provided
    return [...rows].sort((a, b) => {
      let aValue = a[config.key];
      let bValue = b[config.key];

      // Normalize values for comparison (e.g., case-insensitive for strings)
      const normalizedA =
        typeof aValue === "string" ? aValue.toLowerCase() : aValue;
      const normalizedB =
        typeof bValue === "string" ? bValue.toLowerCase() : bValue;

      // Ascending or descending sorting
      if (config.direction === "asc") {
        return normalizedA > normalizedB ? 1 : -1;
      } else {
        return normalizedA < normalizedB ? 1 : -1;
      }
    });
  };

  const table_data = useMemo(() => {
    if (you_table_data?.length > 0 && competitor_table_data?.length > 0) {
      setTableLoader(true);
      const data = getGapAnalyserData(you_table_data, competitor_table_data);
      setTableData(data || []);
      return data || [];
    } else {
      setTableLoader(false);
      setTableData([]);
      return [];
    }
  }, [you_table_data, competitor_table_data]);

  // table paginaton
  const itemsPerPage = 100;

  const gapAnalysisData = useMemo(() => {
    if (tableData?.length === 0) return [];
    return groupUrlsByDomain(tableData);
  }, [tableData]);

  const tableGapData = useMemo(() => {
    if (gapAnalysisData?.length === 0) return [];
    return gapAnalysisData?.map((item, index) => {
      return {
        ...item,
        id: `${item?.domain || "domainUrl"}-${index}`,
        ref_domain: item?.data?.[0]?.domain_from,
        domain_authority:
          Math.round(item?.data?.[0]?.domain_authority / 10) < 5
            ? 0
            : Math.round(item?.data?.[0]?.domain_authority / 10) || 0,
        you_domain: 0,
        competitor_domain: item?.data?.length,
      };
    });
  }, [gapAnalysisData]);

  const sortedRows = useMemo(
    () => sortRows(tableGapData, sortConfig),
    [tableGapData, sortConfig]
  );

  const tableListData = useMemo(() => {
    if (sortedRows?.length === 0) return [];
    if (shouldTableBlur.isTrialUser) return sortedRows.slice(0, 101);
    return sortedRows?.slice(
      Page * itemsPerPage,
      Page * itemsPerPage + itemsPerPage
    );
  }, [sortedRows, Page, shouldTableBlur.isTrialUser]);

  const requestSort = useCallback(
    (key) => {
      let direction = "asc";
      if (sortConfig.key === key && sortConfig.direction === "asc") {
        direction = "desc";
      }
      setSortConfig({ key, direction });
    },
    [sortConfig]
  );

  const handleChangePage = (event, newPage) => {
    const isRestricted =
      shouldTableBlur.showWarning && newPage >= maxAllowedPage;
    if (isRestricted) {
      // Optional: show toast or popup
      showNotification({
        message:
          "🚫You are on free trial now, Please pay and unlock more pages",
        severity: "error",
      });
      return;
    }
    ScrollToView("backlink-table");
    setTableMessage("");
    const maxPage = Math.max(
      0,
      Math.ceil(sortedRows?.length / itemsPerPage) - 1
    );
    if (newPage < 0) {
      setPage(0); // Reset to the first page if negative
    } else if (newPage > maxPage) {
      setPage(maxPage); // Reset to the last page if exceeding limits
    } else {
      setPage(newPage); // Otherwise, set the provided page
    }
    setTableLoader(true);
    setTimeout(() => {
      setTableLoader(false);
    }, 500);
  };

  const filterOption = (data) => {
    if (data?.length === 0) return;
    setTableLoader(true);
    if (tabValue == 1) {
      const filtered_data = data?.filter((item) => {
        const query = item?.dofollow;
        return query ? item : null;
      });
      setTableData(filtered_data);
    } else if (tabValue == 2) {
      const filtered_data = data?.filter((item) => {
        const query = item?.dofollow;
        return !query ? item : null;
      });
      setTableData(filtered_data);
    } else if (tabValue == 0) {
      const sortedData = [...data].sort(
        (a, b) => b.domain_authority - a.domain_authority
      );
      setTableData(sortedData);
    } else {
      setTableData(data);
    }
    setTimeout(() => {
      setTableLoader(false);
    }, 200);
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (
        tableMoreData?.you?.length > 0 &&
        tableMoreData?.competitor?.length > 0
      ) {
        const data = getGapAnalyserData(
          tableMoreData?.you,
          tableMoreData?.competitor
        );
        filterOption([...table_data, ...data]);
      } else {
        filterOption(table_data);
      }
    }, 500);

    return () => {
      clearTimeout(debounce);
    };
  }, [tabValue, table_data]);

  const handleTableSelectedData = useCallback((value) => {
    setSelectedData((prevSelectedData) => {
      if (prevSelectedData?.includes(value)) {
        return prevSelectedData.filter((item) => item !== value);
      } else {
        return [...prevSelectedData, value];
      }
    });
  }, []);

  const isSelectAll = useMemo(
    () => {
      if (tableListData?.length === 0) return false;
      return selectedData?.length === tableListData?.length;
    },
    [selectedData, tableListData] // Dependencies
  );

  const handleTableSelectAll = useCallback(() => {
    const data =
      tableListData?.map((item) => item.domain).filter(Boolean) || [];

    setSelectedData((prev) =>
      prev?.length === tableListData?.length ? [] : data
    );
  }, [tableListData]);

  const isCheckboxChecked = useCallback(
    (value) => {
      return selectedData?.includes(value);
    },
    [selectedData] // Dependencies
  );

  const selectedFilterData = useMemo(() => {
    if (tableListData?.length === 0) return [];
    let data = tableListData?.map((item) => {
      if (selectedData?.includes(item.domain)) {
        return item.data?.[0]?.url_from;
      }
    });
    return data.filter((item) => item !== undefined);
  }, [tableListData, selectedData]);

  const loadCSVData = () => {
    if (table_data?.length === 0) return [];
    const array = shouldTableBlur.isTrialUser
      ? table_data?.slice(0, 100)
      : table_data;
    const CSV_Array = [];
    if (selectedData?.length === 0) {
      array?.map((res) => {
        CSV_Array.push({
          page_title: res?.page_from_title,
          Source: res?.url_from,
          Target: res?.url_to,
          domain_authority: res?.domain_authority,
          Page_authority: res?.page_authority,
          spam_score: `${res?.backlink_spam_score}%`,
          anchor_text: res?.anchor,
          first_seen: formatDate(res?.first_seen),
          last_seen: formatDate(res?.last_seen),
        });
      });
      return CSV_Array;
    } else {
      array?.map((res) => {
        if (selectedData?.includes(res.domain_from)) {
          CSV_Array.push({
            page_title: res?.page_from_title,
            Source: res?.url_from,
            Target: res?.url_to,
            domain_authority: res?.domain_authority,
            Page_authority: res?.page_authority,
            spam_score: `${res?.backlink_spam_score}%`,
            anchor_text: res?.anchor,
            first_seen: formatDate(res?.first_seen),
            last_seen: formatDate(res?.last_seen),
          });
        }
      });
      return CSV_Array;
    }
  };

  const backlinkGetData = async (api) => {
    return await axios.get(api).then((response) => {
      return response;
    });
  };

  const backlinkTotalLmtUpdate = async (
    backlinkLmtGet,
    backlinkTotalLmtGet,
    domain
  ) => {
    let data_len = 200;
    let post_config = {
      email: email,
      domain_name: domain,
      bakclinklmt:
        backlinkLmtGet.data?.[backlinkLmtGet.data?.length - 1]?.limit +
        data_len,
    };
    let post_config2 = {
      email: email,
      backlinktotallmt:
        backlinkTotalLmtGet.data?.[backlinkTotalLmtGet?.data?.length - 1]
          ?.backlinktotallmt - data_len,
    };

    if (backlinkLmtGet.data?.[backlinkLmtGet?.data?.length - 1] < userRowLmt) {
      axios.put(
        update_user_backlinklimit(
          backlinkLmtGet.data?.[backlinkLmtGet.data?.length - 1]?.id
        ),
        post_config
      );
    }

    if (
      backlinkTotalLmtGet?.data[backlinkTotalLmtGet?.data?.length - 1]
        ?.backlinktotallmt <= 0
    ) {
      return;
    }
    axios.put(
      update_backlinktotallmtupdate(
        backlinkTotalLmtGet.data?.[backlinkTotalLmtGet?.data?.length - 1]?.id
      ),
      post_config2
    );
  };

  const handleTableLoadMore = async () => {
    const isRestricted = shouldTableBlur.isTrialUser;
    if (isRestricted) {
      showNotification({
        message:
          "🚫You are on free trial now, Please pay and unlock more pages",
        severity: "error",
      });
      return;
    }
    setLimitAlert("");
    const you_token =
      gap_analyser_data?.[0]?.data?.data?.[0]?.search_after_token ||
      gap_analyser_data?.[0]?.data?.[0]?.search_after_token;
    const competitor_token =
      gap_analyser_data?.[1]?.data?.data?.[0]?.search_after_token ||
      gap_analyser_data?.[1]?.data?.[0]?.search_after_token;

    const config = [
      {
        domain: domain.you,
        include_subdomains: true,
        searchaftertoken:
          sessionStorage.getItem("gap_search_after_token_0") || you_token,
        email: email,
      },
      {
        domain: domain.competitor_1,
        include_subdomains: true,
        searchaftertoken:
          sessionStorage.getItem("gap_search_after_token_1") ||
          competitor_token,
        email: email,
      },
    ];

    try {
      const promises = config?.map(async (item, index) => {
        const total_backlinks =
          gap_analyser_data?.[index]?.data?.data?.[0]?.total_backlinks ||
          gap_analyser_data?.[index]?.data?.[0]?.total_backlinks;
        const table_data =
          gap_analyser_data?.[index]?.data?.data?.[0]?.data ||
          gap_analyser_data?.[index]?.data?.[0]?.data;
        const table_more_data =
          index === 0 ? tableMoreData?.you : tableMoreData?.competitor;
        const shown_table_row = table_data?.length + table_more_data?.length;
        const backlinkLmtGet = await backlinkGetData(
          get_user_backlinklimit(item)
        );
        const backlinkTotalLmtGet = await backlinkGetData(
          get_backlinktotallmtGet(email)
        );

        if (
          backlinkTotalLmtGet?.data[backlinkTotalLmtGet?.data?.length - 1]
            ?.backlinktotallmt <= 0 &&
          shown_table_row >=
            backlinkLmtGet?.data?.[backlinkLmtGet?.data?.length - 1]?.limit
        ) {
          setLimitAlert(t("backlinks.limit_alert"));
          return null;
        } else if (shown_table_row >= total_backlinks) {
          setTableMessage(t("common_buttons.no_data"));
          setTimeout(() => {
            setTableMessage("");
          }, 1000);
          return null;
        }
        setTableMessage(t("backlinks.loading_msg"));
        return axios.post(post_morebacklink(item)).then((response) => {
          if (response.data?.length === 0) {
            setTableMessage(t("common_buttons.no_data"));
            setTimeout(() => {
              setTableMessage("");
            }, 1000);
            return { type: item?.domain, data: table_more_data };
          } else {
            backlinkTotalLmtUpdate(
              backlinkLmtGet,
              backlinkTotalLmtGet,
              item?.domain
            );
            const new_data = response.data?.[0];
            sessionStorage.setItem(
              `gap_search_after_token_${index}`,
              new_data?.search_after_token || ""
            );
            setTableMessage("");
            return {
              type: item.domain,
              data: new_data?.data,
            };
          }
        });
      });
      // Wait for all promises to resolve
      await Promise.all(promises).then((response) => {
        // response
        if (
          response?.[0]?.data?.length > 0 &&
          response?.[1]?.data?.length > 0
        ) {
          setTableMoreData((pre) => ({
            you: [...pre.you, ...response?.[0]?.data],
            competitor: [...pre.competitor, ...response?.[1]?.data],
          }));
          const data = getGapAnalyserData(
            response?.[0]?.data || [],
            response?.[1]?.data || []
          );
          filterOption([...table_data, ...data]);
        } else {
          setTableMessage(t("backlinks.no_more_data_found"));
          setTimeout(() => {
            setTableMessage("");
          }, 1000);
        }
      });
    } catch (error) {
      setTableMessage("backlinks.no_more_data_found");
      setTimeout(() => {
        setTableMessage("");
      }, 1000);
      // error
    }
  };

  const postBacklinkLimit = (data, domain) => {
    let post_config = {
      email: email,
      domain_name: domain,
      bakclinklmt: data?.length,
    };
    const rowLmt = backlinklimits?.backlinks_rows_limit;
    axios.post(post_user_backlinklimit(), post_config);
    axios.get(get_backlinktotallmtGet(email)).then((response) => {
      if (response.data?.length > 0) {
        axios.put(
          update_backlinktotallmtupdate(
            response?.data[response?.data?.length - 1].id
          ),
          {
            email: email,
            backlinktotallmt:
              response?.data[response?.data?.length - 1].backlinktotallmt -
              data?.length,
          }
        );
      } else if (response.data?.length === 0) {
        axios.post(post_backlinktotallmt(), {
          email: email,
          backlinktotallmt: rowLmt - data?.length,
        });
      }
    });
  };

  const handleBacklinkData = async (result) => {
    try {
      const promises = result?.map(async (domain, index) => {
        const config = {
          email: email,
          domain: domain.name,
          include_subdomains: true,
        };
        return axios.get(get_backlink_data(config)).then(async (response) => {
          if (response.data?.length > 0) {
            const data = response.data?.[0];
            sessionStorage.setItem(
              `gap_search_after_token_${index}`,
              data.data?.[0]?.search_after_token || ""
            );

            return { name: domain.name, type: domain.type, data };
          } else {
            const get_lmt_response = await axios.get(
              get_backlinktotallmtGet(email)
            );
            const userLmt =
              get_lmt_response?.data[get_lmt_response?.data?.length - 1]
                ?.backlinktotallmt;
            if (get_lmt_response?.data?.length > 0) {
              if (userLmt <= 0) {
                setLimitAlert(t("backlinks.limit_alert"));
                return { name: domain.name, type: domain.type, data: [] };
              }
            }
            const response = await axios.post(post_backlink_data(config));
            if (response?.data?.length === 0) {
              setError(
                `Sorry, No Data Found For This ${config.domain}. Please Check The ${config.domain}.`
              );
              return { name: domain.name, type: domain.type, data: [] };
            } else {
              const backlink_data = response?.data[0]?.data;
              sessionStorage.setItem(
                "search_after_token",
                response?.data[0]?.search_after_token || ""
              );
              postBacklinkLimit(backlink_data, config.domain);
              return {
                name: domain.name,
                type: domain.type,
                data: response?.data,
              };
            }
          }
        });
      });
      // Wait for all promises to resolveFcsv
      await Promise.all(promises).then((response) => {
        setLoader(false);
        ZustandStore.setState({
          gap_analyser_data: response,
        });
      });
    } catch (error) {
      setLoader(false);
      ZustandStore.setState({
        gap_analyser_data: [],
      });
      removeQueryParamToURL();
    }
  };

  const keywordClickHandler = (e) => {
    if (!isPageAccess) return;
    e.preventDefault();
    if (domain.you === "" && domain.competitor_1) {
      setError({
        msg: t("competitive_research.alert_msg.enter_domain"),
        show: true,
      });
    } else if (
      !domainRegex.test(domain.you) &&
      !domainRegex.test(domain.competitor_1)
    ) {
      setError({
        msg: t("competitive_research.alert_msg.valid_domain"),
        show: true,
      });
      ZustandStore.setState({
        gap_analyser_data: [],
      });
    } else {
      setLoader(true);
      sessionStorage.setItem("yourlastbacklinkdomain", domain.you);
      sessionStorage.setItem(
        "competitorlastbacklinkdomain",
        domain.competitor_1
      );
      const config = [
        {
          name: domain?.you,
          type: "your",
        },
        {
          name: domain?.competitor_1,
          type: "competitor",
        },
      ];
      setLimitAlert("");
      addQueryParamToURL(domain.you, domain.competitor_1);
      const youconfig = {
        domain: domain?.you,
        type: "backlinks",
      };
      const competitorconfig = {
        domain: domain?.competitor_1,
        type: "backlinks",
      };
      ZustandStore.setState({
        history_data: {
          data: [],
          error: false,
          loading: true,
        },
      });
      handleSaveHistory(competitorconfig);
      handleSaveHistory(youconfig);
      handleBacklinkData(config);
    }
  };

  const handleReset = (e) => {
    setDomain({
      you: "",
      competitor_1: "",
    });
    ZustandStore.setState({
      gap_analyser_data: [],
    });
    setTableMoreData({
      you: [],
      competitor: [],
    });
    sessionStorage.removeItem("yourlastbacklinkdomain");
    sessionStorage.removeItem("competitorlastbacklinkdomain");
  };

  const removeQueryParamToURL = () => {
    const parametersToRemove = ["your", "competitors"];
    const searchParams = new URLSearchParams(location.search);
    parametersToRemove.forEach((param) => {
      searchParams.delete(param);
    });

    const newSearch = searchParams.toString();
    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
    navigate(newUrl);
  };

  const addQueryParamToURL = (your, competitor) => {
    if (your) {
      queryParams.set("your", your);
      queryParams.set("competitors", competitor);
    } else {
      queryParams.delete("your");
      queryParams.delete("competitors");
    }
    const newSearch = queryParams.toString();
    navigate({ search: `?${newSearch}` });
  };

  function groupUrlsByDomain(array) {
    const domainMap = {};
    // Iterate through each URL
    array.forEach((urlObj) => {
      const domain = urlObj.domain_from;
      // If domain not in map, create an array to hold URLs
      if (!domainMap[domain]) {
        domainMap[domain] = { domain: domain, data: [] };
      }
      // Push URL into corresponding domain's data array
      domainMap[domain].data.push(urlObj);
    });
    // Convert map values to array
    const result = Object.values(domainMap);
    return result;
  }

  const headers = [
    {
      label: "Page Title",
      key: "page_title",
    },
    {
      label: "Source Url",
      key: "Source",
    },
    {
      label: "Target Url",
      key: "Target",
    },
    { label: "Domain Authority", key: "domain_authority" },
    { label: "Page Authority", key: "Page_authority" },
    { label: "Spam Score", key: "spam_score" },
    { label: "Anchor Text", key: "anchor_text" },
    { label: "First Seen", key: "first_seen" },
    { label: "Last Seen", key: "last_seen" },
  ];

  const FetchLISTING = () => {
    axios.get(GET_ALLLIST_BACKLINKS(EMAIL)).then((Result) => {
      if (Result?.data) {
        setViewAllLists(Result?.data);
        setSelectedData([]);
      }
    });
  };

  useEffect(() => {
    FetchLISTING();
  }, []);

  const PAYLOAD = {
    email: EMAIL,
    back_list_name: ListValue,
    backlink_list: selectedFilterData,
  };

  const handleUserAddList = () => {
    const config = {
      email: EMAIL,
      url: selectedFilterData,
    };

    axios.post(USER_BACKLINK_LIST_URLEML(), config);
    axios.post(USER_BACKLINK_LIST_URL(), {
      url: selectedFilterData,
    });
  };

  const HandleCreateBackLIST = () => {
    setalertMsg(false);
    if (ListValue) {
      const Output = ViewAllLists.map((result) => {
        return result.back_list_name === ListValue;
      });
      const ReturnData = Output.includes(true);
      if (ReturnData) {
        setalertMsg(true);
        setTimeout(() => {
          setalertMsg(false);
        }, 3000);
      } else {
        handleUserAddList();
        axios.post(POST_NEWLIST_BACKLINKS(), PAYLOAD).then((res) => {
          setAlert({
            type: "success",
            message: "Created Successfully",
            show: true,
          });
          setSelectedData([]);
          setListValue("");
          FetchLISTING();
          setAnchorEl(false);
          setCreateList(false);
          setinputEmptyErr(false);
        });
      }
    } else {
      setinputEmptyErr(true);
    }
  };

  const handleGetListData = (listData) => {
    setListChooseErr(false);
    setListName(listData?.back_list_name);
  };

  const handleAddBackLink = () => {
    let obj = {
      data: [],
    };
    ViewAllLists?.map((all) => {
      if (all.back_list_name === ListName) {
        const BackLink_list = all.backlink_list;
        const namesInArray1 = new Set(BackLink_list.map((item) => item));
        const array = selectedFilterData.filter(
          (item) => !namesInArray1.has(item)
        );
        obj.data.push(array);
      }
    });
    if (ListName) {
      axios.put(PUT_ADDBACKLINKS(EMAIL, ListName, ...obj.data)).then((res) => {
        setAlert({
          type: "success",
          message: "Added Successfully",
          show: true,
        });
        setListName("");
        setSelectedData([]);
        FetchLISTING();
        setAnchorEl(false);
        setCreateList(false);
      });
    } else {
      setListChooseErr(true);
    }
  };

  const HandleDeleteList = (LIST) => {
    setDeleteLoading(true);
    axios.delete(DELETE_LIST_BACKLINKS(EMAIL, LIST)).then((res) => {
      setAlert({
        type: "success",
        message: "Deleted",
        show: true,
      });
      FetchLISTING();
      setTimeout(() => {
        setDeleteLoading(false);
      }, 500);
    });
  };

  const AddColor = (id) => {
    const Elem = document.getElementsByClassName("ListName");
    const Target = document.getElementById(id);
    for (let index = 0; index < Elem.length; index++) {
      Elem[index].classList.remove("SHOWBg");
    }
    document.getElementById(id).classList.add("SHOWBg");
  };

  const handleListNavigate = () => {
    sessionStorage.setItem("backlinkgapback", true);
    navigate("/view-backlink-lists");
  };
  //  List End

  const tableHeader = useMemo(() => {
    const you_domain =
      sessionStorage.getItem("yourlastbacklinkdomain") ||
      domain.you ||
      "Your domain";
    const competitor_domain =
      sessionStorage.getItem("competitorlastbacklinkdomain") ||
      domain.competitor_1 ||
      "Your domain";
    return [
      {
        label: t("backlinks.backlinks_gap.table.header.ref_domain.title"),
        dataKey: "ref_domain",
        sort: "domain_from",
        align: "left",
        width: "auto",
        tooltip: t("backlinks.backlinks_gap.table.header.ref_domain.tooltip"),
        show: true,
        ignore: true,
      },
      {
        label: t("backlinks.backlinks_gap.table.header.dr.title"),
        dataKey: "domain_authority",
        sort: "domain_authority",
        align: "left",
        width: "120px",
        tooltip: t("backlinks.backlinks_gap.table.header.dr.tooltip"),
        show: true,
        ignore: true,
      },
      {
        label: you_domain,
        dataKey: "you_domain",
        svg: <YouBlueDotSvg />,
        sort: false,
        align: "left",
        width: "300px",
        tooltip: false,
        customToolTip: {
          ref_domain: you_history_list?.[0]?.referring_domains || 0,
          backlinks: you_total_backlinks || 0,
        },
        show: true,
        ignore: true,
      },
      {
        label: competitor_domain,
        dataKey: "competitor_domain",
        sort: "competitorlastbacklinkdomain",
        align: "left",
        svg: <YouDotSvg />,
        width: "300px",
        tooltip: false,
        customToolTip: {
          ref_domain: competitor_history_list?.[0]?.referring_domains || 0,
          backlinks: competitor_total_backlinks || 0,
        },
        show: true,
        ignore: true,
      },
    ];
  }, [
    you_history_list,
    you_total_backlinks,
    competitor_total_backlinks,
    competitor_history_list,
    t,
  ]);

  return (
    <section className="backlink_gap_container main-pd" id="backlink_page">
      {limitAlert ? <LineAlert data={limitAlert} /> : null}
      <div className="gap_search pb-4 w-100">
        <h5 className="">{t("backlinks.backlinks_gap.title")}</h5>
        <p className="keyword-p">{t("backlinks.backlinks_gap.des")}</p>
        <form
          onSubmit={(e) => {
            keywordClickHandler(e);
          }}
        >
          <div className="overview-search-contain">
            <div className="root_domain">
              <label className="mb-1">
                {t("backlinks.backlinks_gap.root_domain")}
              </label>
              <div className="input_contain">
                <YouSvg />
                <input
                  type="text"
                  name="you"
                  value={domain.you}
                  onChange={handleInputChange}
                  placeholder={t(
                    "backlinks.backlinks_gap.placeholders.your_domain"
                  )}
                  autoComplete="off"
                  style={{ width: "73%" }}
                />
                <IoClose
                  className="clear_domain"
                  onClick={() =>
                    setDomain((pre) => ({
                      ...pre,
                      you: "",
                    }))
                  }
                />
              </div>
            </div>

            <div className="root_domain">
              <label className="mb-1">
                {t("backlinks.backlinks_gap.root_domain")}
              </label>
              <div className="input_contain">
                <YouDotSvg />
                <input
                  type="text"
                  name="competitor_1"
                  value={domain.competitor_1}
                  onChange={handleInputChange}
                  placeholder={t(
                    "backlinks.backlinks_gap.placeholders.compititor_domain"
                  )}
                  autoComplete="off"
                  style={{ width: "89%" }}
                />

                <IoClose
                  className="clear_domain"
                  onClick={() =>
                    setDomain((pre) => ({
                      ...pre,
                      competitor_1: "",
                    }))
                  }
                />
              </div>
            </div>

            <button
              className="gap_analyser_btn"
              type="submit"
              disabled={!isPageAccess}
            >
              {t("backlinks.backlinks_gap.submit_button")}
            </button>
            <button
              type="reset"
              className="gap_clear_btn"
              disabled={domain.you === "" && domain.competitor_1 === ""}
              onClick={(e) => handleReset(e)}
            >
              {t("backlinks.backlinks_gap.clear_button")}
            </button>
            <Link to={"/activity?type=backlinks"} className="">
              <button className="icon-btn" title="Activity" style={{}}>
                <HistoryIcon
                  style={{ width: "18px", height: "18px" }}
                  className="me-1"
                />{" "}
                {t("common_buttons.activity")}
              </button>
            </Link>
          </div>
          {isPageAccess ? (
            <>
              {gap_analyser_data?.length === 0 ? (
                <LastCheck type="backlinks" />
              ) : null}
              {Error?.show ? (
                <p className="vl-msd-line mt-1 ms-1">
                  <span>{Error?.msg}</span>
                </p>
              ) : null}
            </>
          ) : (
            <p className="heading-medium font-bold vl-msd-line mt-3 ms-1">
              <span>{t("backlinks.altert")}</span>
            </p>
          )}
        </form>
      </div>

      {loader ? (
        <DottLoader />
      ) : gap_analyser_data?.length === 0 ? null : (
        <>
          <Box className="gap-tab-container" id="backlink-table">
            <Button
              variant="contained"
              sx={{ height: "41px" }}
              className="icon-btn"
            >
              <DropdownList
                key={"filterdropdown"}
                title={t("common_buttons.filter")}
                style={{ width: "auto" }}
                data={filterOptionArr}
                selectOption={filterOptionArr[tabValue]}
                onValueSelect={handleTabChange}
              />
            </Button>
            <button
              className="icon-btn large-btn ms-auto"
              onClick={HandleOpen}
              title={t("backlinks.backlink_analysis.buttons.add_domain.title")}
              disabled={selectedData?.length === 0}
            >
              <img src={addIcon} alt="" className="me-1" />{" "}
              {t("backlinks.backlink_analysis.buttons.add_domain.title")}
            </button>

            {table_data?.length > 0 && (
              <CSVLink
                style={{
                  textDecoration: "none",
                  color: "red",
                }}
                filename={
                  "SEO Tools:" + "Backlink Gap Analyzer" + curday() + ".csv"
                }
                headers={headers}
                data={loadCSVData()}
              >
                <button
                  style={{ backgroundColor: "#e95655" }}
                  title={t(
                    "rank_tracking.rank_tracker.table_filter.export_file.title"
                  )}
                  disabled={tableListData?.length === 0}
                >
                  <img src={exportIcon} alt="" className="me-1" />{" "}
                  {t("common_buttons.export")}
                </button>
              </CSVLink>
            )}

            <button
              className="icon-btn large-btn view-icon"
              onClick={() => handleListNavigate()}
              title={t("backlinks.backlinks_gap.view_domain_list")}
            >
              <CiCircleList className="me-1" />{" "}
              {t("backlinks.backlinks_gap.view_domain_list")}
            </button>

            <FiDownload
              className="down large-btn"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              title="download Long Title pdf"
            />

            <PdfModalDialog>
              <DomainRankPdfModal
                sortTableData={tableListData}
                domain={domain}
              />
            </PdfModalDialog>
          </Box>

          <Paper
            className={"w-100 mt-3 vir-table-border"}
            sx={{
              backgroundColor: "background.paper",
              boxShadow: "none",
              "& .MuiTableContainer-root": {
                boxShadow: "none",
                borderRadius: 0,
              },
            }}
          >
            <CollapsibleTable
              {...{
                header: tableHeader,
                rows: tableListData,
                requestSort,
                tableLoader,
                handleTableSelectAll,
                isSelectAll,
                isCheckboxChecked,
                handleTableSelectedData,
                isTableBlur: shouldTableBlur?.showWarning,
              }}
            />
            <TablePagination
              sx={{
                borderTop: "1px solid rgba(224, 224, 224, 1)",
                cursor: "default",
                "& .MuiTablePagination-actions": {
                  width: 90,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                },
                "& .MuiTablePagination-displayedRows": {
                  padding: 0,
                  margin: 0,
                },
                "& .MuiTablePagination-selectLabel": {
                  padding: 0,
                  margin: 0,
                },
              }}
              rowsPerPage={100}
              rowsPerPageOptions={[100]}
              onRowsPerPageChange={() => {}}
              component="div"
              disabled={sortedRows?.length === 0}
              count={sortedRows?.length}
              page={Page}
              onPageChange={handleChangePage}
              ActionsComponent={(props) =>
                TablePaginationActions(
                  props,
                  tableListData,
                  tableMessage,
                  handleTableLoadMore
                )
              }
            />
          </Paper>
        </>
      )}

      <AlertPopUp config={Alert} handleClose={setAlert} />

      <PopOver anchorEl={anchorEl} setAnchorEl={() => setAnchorEl(false)}>
        {CreateList ? (
          <>
            <Box sx={{ width: "100%" }} padding={"1rem"}>
              <Typography
                component="h1"
                id="select-google-property"
                className="heading-large font-bold popover-list-header py-2 px-2"
              >
                {t("backlinks.backlinks_gap.create_backlinks_list")}
                <IconButton
                  className="popover-close-icon"
                  onClick={handleClose}
                  sx={{
                    marginRight: "10px",
                    marginTop: "13px",
                    "&:hover": {
                      backgroundColor: "rgba(240, 242, 255, 1)",
                    },
                  }}
                >
                  <CloseIcon sx={{ color: "black" }} fontSize="medium" />
                </IconButton>
              </Typography>
              <Grid
                padding={"0"}
                container
                spacing={2}
                columns={12}
                className="mb-2"
                sx={{ maxWidth: { md: 500 }, minWidth: { md: 500 } }}
              >
                <div className="row w-100">
                  <div className="col-md-12 col-12 col-lg-12">
                    <div className="AddListBox p-0">
                      <div
                        className="add-pr-url"
                        style={{ padding: "1rem 0rem 1rem 1.5rem" }}
                      >
                        <input
                          type="text"
                          autoComplete="true"
                          placeholder="BACKLINK LIST NAME"
                          onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                              HandleCreateBackLIST();
                            }
                          }}
                          onChange={(e) => {
                            setListValue(e.target.value);
                            setinputEmptyErr(false);
                          }}
                        ></input>
                        {alertMsg && (
                          <h6
                            style={{
                              marginTop: "10px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "red",
                              width: "100%",
                            }}
                          >
                            {" "}
                            {t(
                              "backlinks.backlinks_gap.typo.list_name_already_exist"
                            )}
                          </h6>
                        )}

                        {inputEmptyErr && (
                          <h6
                            style={{
                              marginTop: "10px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "red",
                              width: "100%",
                            }}
                          >
                            {" "}
                            {t("backlinks.backlinks_gap.typo.type_something")}
                          </h6>
                        )}

                        <div className="cmd mt-4  w-100">
                          <button
                            className="cm-btn-b"
                            onClick={() => {
                              handleClose();
                            }}
                          >
                            {t("common_buttons.cancel")}
                          </button>
                          <button
                            className="cm-btn"
                            onClick={HandleCreateBackLIST}
                          >
                            {t("common_buttons.submit")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 1)",
            }}
            className="popover-cont"
          >
            {/* {data?.length > 0 ? ( */}
            <Box sx={{ width: "100%" }}>
              <Typography
                component="h1"
                fontWeight={400}
                id="select-google-property"
                className="heading-large font-bold popover-list-header py-2 px-2"
              >
                {t("backlinks.backlinks_gap.typo.select_list")}
                <IconButton
                  className="popover-close-icon"
                  onClick={handleClose}
                  sx={{
                    marginRight: "5px",
                    marginTop: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(240, 242, 255, 1)",
                    },
                  }}
                >
                  <CloseIcon sx={{ color: "black" }} fontSize="mediun" />
                </IconButton>
              </Typography>
              <Grid
                container
                spacing={2}
                columns={12}
                className="mb-2"
                sx={{
                  maxWidth: { md: 500 },
                  minWidth: { md: 500 },
                  marginLeft: "-7px",
                  overflow: "hidden",
                }}
              >
                {ViewAllLists?.length > 0 ? (
                  <>
                    <ul className="listOfName w-100 mt-3 mx-3">
                      {DeleteLoading ? (
                        <div>
                          <div
                            className="d-flex justify-content-center align-items-center "
                            style={{ height: "35vh" }}
                          >
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden"></span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ViewAllLists?.map((listItem, index) => {
                          return (
                            <li
                              className="ListName d-flex justify-content-between"
                              id={index}
                              key={index}
                              onClick={() => {
                                AddColor(index);
                                handleGetListData(listItem);
                              }}
                            >
                              <p className="m-0 p-1">
                                {" "}
                                {listItem.back_list_name}
                              </p>
                              <Delete
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  HandleDeleteList(listItem.back_list_name)
                                }
                              />
                            </li>
                          );
                        })
                      )}
                    </ul>
                    <h4 className="fs-6 mt-2  text-center w-100">
                      <b>OR</b>
                    </h4>
                  </>
                ) : (
                  <></>
                )}
                <div
                  style={{
                    border:
                      !ViewAllLists.length > 0 ? "1px solid #a4a9af9c" : "none",
                    height: !ViewAllLists.length > 0 ? "11vh" : "auto",
                    width: !ViewAllLists.length > 0 ? "95%" : "auto",
                    display: !ViewAllLists.length > 0 ? "flex" : "auto",
                    justifyContent:
                      !ViewAllLists.length > 0 ? "center" : "auto",
                    alignItems: !ViewAllLists.length > 0 ? "center" : "auto",
                    margin:
                      !ViewAllLists.length > 0
                        ? "20px auto 10px auto"
                        : "8px auto 0px auto",
                  }}
                >
                  <button
                    className="AddListName mb-1"
                    onClick={HandleOpenAddList}
                  >
                    {t("backlinks.backlinks_gap.typo.create_list")}
                  </button>
                </div>
                <div className="errorList m-0 w-100">
                  {ListChooseErr && (
                    <h6
                      style={{
                        marginTop: "10px",
                        marginLeft: "10px",
                        textAlign: "left",
                        fontSize: "12px",
                        color: "red",
                      }}
                    >
                      {" "}
                      {t("backlinks.backlinks_gap.typo.select_one_list")}
                    </h6>
                  )}
                </div>
                <div className="cmd mt-2 ms-2 me-2 w-100 px-2">
                  <button
                    className="cm-btn-b"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    {t("common_buttons.cancel")}
                  </button>
                  <button className="cm-btn" onClick={handleAddBackLink}>
                    {t("common_buttons.submit")}
                  </button>
                </div>
              </Grid>
            </Box>
          </Box>
        )}
      </PopOver>
    </section>
  );
};

export default BacklinkGap;
